// extracted by mini-css-extract-plugin
export var aircallIframe = "_eh-3";
export var fabContainer = "_eh-5";
export var fabRinging = "_eh-6";
export var loadingOverlay = "_eh-4";
export var pulse = "_eh-7";
export var widgetContent = "_eh-2";
export var widgetPanel = "_eh-0";
export var widgetPanelExpanded = "_eh-1";